<template>
    <div class="row">
        <!--Title-->
        <div class="text-right col-md-12">
                <p-button 
                    v-if="tableData && tableData.length && !this.$apollo.queries.amountTermsFa.loading"
                    @click="handleAdd" 
                    type="warning" 
                    outline>Agregar Monto y Plazo
                    <i class="ml-2 fa fa-plus"></i>
                </p-button>
                <h4 class="title center-title pull-left">Montos y Plazos - Activo fijo</h4>
        </div>
        <!--./Title-->
        <!--Loading state-->
        <loading :active.sync="this.$apollo.queries.amountTermsFa.loading"
        :can-cancel="false" 
        :is-full-page="fullPage">
        </loading>
        <!--./Loading state-->
        <!--Sending state-->
        <loading :active.sync="isSending"
        :can-cancel="false" 
        :is-full-page="fullPage">
        </loading>
        <!--./Sending state-->
        <!--Empty state-->
        <div v-if="tableData && !tableData.length && !this.$apollo.queries.amountTermsFa.loading" class="mt-3 col-md-12 card">
        <div class="card-header">
        </div>
        <div class="card-body">
            <img class="no_data_center"  v-bind:src="no_data_image" alt="">
        </div>
        <div class="card-footer text-center">
            <p-button 
                @click="handleAdd" 
                type="warning" 
                outline>Agregar monto y plazo
                <i class="ml-2 fa fa-plus"></i>
            </p-button>            
        </div>
        </div>
        <!--./Empty state-->
        <!--Regionals data-->
        <div v-if="tableData &&  tableData.length && !this.$apollo.queries.amountTermsFa.loading" class="col-md-12 card">
        <div class="card-header">
            <div class="category">Lista de tipos de montos y plazos</div>
        </div>
        <div class="card-body row">
            <div class="col-sm-4">
                <div>
                    <fg-input class="input-sm"
                            placeholder="Buscar"
                            v-model="searchQuery"
                            addon-right-icon="nc-icon nc-zoom-split">
                    </fg-input>
                </div>
            </div>
            <div class="col-sm-12 mt-2">
            <el-table class="table-striped"
                        :data="queriedData"
                        border
                        style="width: 100%">
                <el-table-column label="Desde">
                    <template slot-scope="scope">
                        <span >{{ setFormat(scope.row.from)}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="Hasta">
                    <template slot-scope="scope">
                        <span >{{ setFormat(scope.row.to)}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                :min-width="120"
                fixed="right"
                class-name="td-actions"
                label="Acciones">
                <template slot-scope="props">
                    <el-tooltip content="Ver" placement="left">
                        <p-button type="warning" size="sm" icon @click="handleShow(props.$index, props.row)">
                            <i class="fa fa-eye"></i>
                        </p-button>
                    </el-tooltip>
                    <el-tooltip content="Editar" placement="top">
                        <p-button type="primary" size="sm" icon @click="handleEdit(props.$index, props.row)">
                            <i class="fa fa-edit"></i>
                        </p-button>
                    </el-tooltip>
                    <el-tooltip v-show="props.row.active" content="Desactivar" placement="right">
                        <p-button type="danger" size="sm" icon @click="handleDeactivate(props.$index, props.row)">
                            <i class="fa fa-pause"></i>
                        </p-button>
                    </el-tooltip>
                    <el-tooltip  v-show="!props.row.active" content="Activar" placement="right">
                        <p-button type="success" size="sm" icon @click="handleActivate(props.$index, props.row)">
                            <i class="fa fa-play"></i>
                        </p-button>
                    </el-tooltip>
                </template>
                </el-table-column>
            </el-table>
            </div>
            <div class="col-sm-6 pagination-info">
            <p class="category">Mostrando {{from + 1}} a {{to}} de {{total}} registros</p>
            </div>
            <div class="col-sm-12 mt-2">
                <el-select
                    class="select-default pull-left"
                    v-model="pagination.perPage"
                    placeholder="Per page">
                    <el-option
                    class="select-default"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
                <p-pagination class="pull-right"
                                v-model="pagination.currentPage"
                                :per-page="pagination.perPage"
                                :total="pagination.total">
                </p-pagination>
            </div>
        </div>
        </div>
        <!--./Regionals data-->
        <!--Add Regional form-->
        <div v-if="(addAmountTermsFA == true || editAmountTermsFA == true || showAmountTermsFA == true) && !this.$apollo.queries.amountTermsFa.loading" class="col-md-12 card">
            <form>
                <div class="card-header">
                    <h4 class="card-title">
                    {{formName}}
                    </h4>
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label>Desde</label>
                        <fg-input   :disabled="showAmountTermsFA" 
                                    ref="from"
                                    type="numeric"
                                    name="desde"
                                    autocomplete="off"
                                    v-validate="modelValidations.from"
                                    :error="getError('desde')"
                                    v-model="model.from">
                        </fg-input>
                    </div>
                    <div class="form-group">
                        <label>Hasta</label>
                        <fg-input   :disabled="showAmountTermsFA" 
                                    ref="to"
                                    type="numeric"
                                    name="hasta"
                                    autocomplete="off"
                                    v-validate="modelValidations.to"
                                    :error="getError('hasta')"
                                    v-model="model.to">
                        </fg-input>
                    </div>
                    <div class="form-group" v-for="clientType in clientTypes_array" :key="clientType.id">
                        <label>{{ clientType.name }}</label>
                        <fg-input  
                            :disabled="showAmountTermsFA" 
                            ref="clientType.name"
                            type="numeric"
                            :name="clientType.name"
                            autocomplete="off"
                            v-validate="modelValidations.value"
                            :error="getError(clientType.name)"
                            v-model="model[clientType.name]">
                        </fg-input>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                        <p-button :disabled="showAmountTermsFA" type="success" @click.prevent="validate">Aceptar</p-button>
                        <p-button type="default" class="pull-left" @click="cancelForm">Cancelar</p-button>
                    </div>
                </div>
            </form>
        </div>
        <!--./Add Regional form-->
    </div>
    
    </template>
    <script>
    import swal from 'sweetalert2'
    import Vue from 'vue'
    import {Table, TableColumn, Select, Option} from 'element-ui'
    import PPagination from 'src/components/UIComponents/Pagination.vue'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { Tooltip } from 'element-ui'
    import gql from 'graphql-tag'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import { clientTypes } from 'src/api/graphql/queries/setup/AllClientTypes';
    import { amountTermsFa } from 'src/api/graphql/queries/setup/AllAmountTermsFA';
    import { CREATE_AMOUNT_TERMS_FA } from 'src/api/graphql/mutations/setup/AddEditAmountTermsFA';
    import { orderBy , sortBy , find } from 'lodash';
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    export default{
        /***
        * Esta es la función para hacer todos los llamados de GraphQL al servidor mediante VueApollo
        *
        **/
        apollo:{
        clientTypes: {
                    query: clientTypes,
                    skip: false,
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        
                        if(data.clientTypes.edges.length == 0)
                        {
                            this.clientTypes_array = [];
                        }
                        else
                        {
                            this.setClientTypes(data.clientTypes);
                            this.$apollo.queries.clientTypes.skip = true;
                        }
                        
                    },
                    // Si encontró algún error.
                    error(error) {
                        
                    },
                },
            amountTermsFa: {
                    query: amountTermsFa,
                    skip: false,
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {
                        
                        if(data.amountTermsFa.edges.length == 0)
                        {
                            this.amountTermsFa_array = [];
                        }
                        else
                        {
                            this.setAmountTermsWc(data.amountTermsFa);
                            this.$apollo.queries.amountTermsFa.skip = true;
                        }
                        
                    },
                    // Si encontró algún error.
                    error(error) {
                        
                    },
                },
        },
        components: {
        PPagination,
        Loading,
        [Tooltip.name]: Tooltip,
        Select,
        Option,
        },
        computed: {
        
        pagedData () {
            return this.tableData.slice(this.from, this.to)
        },
        /***
        * Searches through table data and returns a paginated array.
        * Note that this should not be used for table with a lot of data as it might be slow!
        * Do the search and the pagination on the server and display the data retrieved from server instead.
        * @returns {computed.pagedData}
        */
        queriedData () {
            if (!this.searchQuery) {
            this.pagination.total = this.tableData.length
            return this.pagedData
            }
            let result = this.tableData
            .filter((row) => {
                let isIncluded = false
                for (let key of this.propsToSearch) {
                let rowValue = row[key].toString().toLowerCase();
                if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
                    isIncluded = true
                }
                }
                return isIncluded
            })
            this.pagination.total = result.length
            return result.slice(this.from, this.to)
        },
        to () {
            let highBound = this.from + this.pagination.perPage
            if (this.total < highBound) {
            highBound = this.total
            }
            return highBound
        },
        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1)
        },
        total () {
            this.pagination.total = this.tableData.length
            return this.tableData.length
        }
        },
        data () {
        return {
            no_data_image : process.env.VUE_APP_BASE_ROUTE+'img/no_data.png',
            isSending: false,
            fullPage: false,
            tableData: [],
            amountTermsFa_array : [],
            clientTypes_array : [],
            addAmountTermsFA : false,//Bandera de creación de tipo de cuota contingente
            editAmountTermsFA : false,//Bandera de edición de tipo de cuota contingente
            showAmountTermsFA: false,
            rowEdit: {},
            rowShow: {},
            formName: 'Cargando...',//Nombre del formulario de creación/edición
            model: {
                id: '',
                from: '',
                to: '',
                active: true
            },
            modelValidations: {
            code: {
                required: true,
                max: 8
            },
            name: {
                required: true,
                max: 32
            },
            from: {
                required: true,
                numeric: true
            },
            to: {
                required: true,
                numeric: true
            },
            value: {
                required: true,
                numeric: true
            },
            },
            pagination: {
            perPage: 5,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
            total: 0
            },
            searchQuery: '',
            propsToSearch: ['from'],
            tableColumns: [
            {
                prop: 'from',
                label: 'Desde',
                minWidth: 250
            },
            {
                prop: 'to',
                label: 'Hasta',
                minWidth: 250
            }
            ],
        }
        },
        methods: {
            /*** 
            * Función que se dispara cuando se da clic en Desactivar tipo de cliente
            */
            handleDeactivate (index, row) {
                var vm = this;
                swal({
                    title: '¿Estás seguro?',
                    text: 'Si aceptas, desactivarás la parametrización seleccionada',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Si, desactivar',
                    cancelButtonText: 'No, cancelar',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    buttonsStyling: false
                }).then(() => {
                    var vm = this;
                    var formInput = {};
                    var formMessage = ""; 
                    vm.isSending = true;
                    // Asignar los valores from y to de la fila al modelo
                    vm.model.id = row.id
                    vm.model.from = row.from;
                    vm.model.to = row.to;
                    vm.model.active = false;

                    // Inicializar los valores de client types en el modelo
                    vm.clientTypes_array.forEach(type => {
                        // Asumimos que el objeto `row` tiene las claves correspondientes a los tipos de cliente
                        // Por ejemplo: row.ELITE, row.ELITE_PLUS, etc.
                        vm.model[type.name] = row.data[type.name] !== undefined ? row.data[type.name] : null;
                    });
                    var new_id = vm.idDecode(vm.model.id);
                    let { id, ...modelWithoutId } = vm.model;
                    formInput = {
                        id: new_id,
                        data: JSON.stringify(modelWithoutId)
                    };
                    
                    // Iniciamos el envío de la mutación
                    this.$apollo.mutate({
                        mutation: CREATE_AMOUNT_TERMS_FA,
                        variables : {
                            input : formInput
                        }
                    }).then((data) => {
                        if (data.data.amountTermsFa.errors.length == 0) {
                            let indexToDelete = vm.tableData.findIndex((tableRow) => tableRow.id === row.id)
                            if (indexToDelete >= 0) {
                                vm.tableData.splice(indexToDelete, 1)
                            }
                            vm.pushAmountData(data.data.amountTermsFa.amountTermsFA);
                            vm.isSending = false;
                            swal({
                            title: '¡Desactivada!',
                            text: 'La parametrización ha sido desactivada',
                            type: 'success',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            buttonsStyling: false
                            }).then(() => {
                                vm.reloadData();
                            },function (dismiss){
                                vm.reloadData();
                            });
                        }
                        else {
                            vm.isSending = false;
                            vm.showNotificationError(data.data.amountTermsFa.errors[0].messages[0]);
                        }
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.onError('Ha ocurrido un error, inténtalo de nuevo');
                    });
                    
                }, function (dismiss) {
                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                    swal({
                        title: 'Cancelado',
                        text: 'La parametrización no ha sido desactivada',
                        type: 'error',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        buttonsStyling: false
                    })
                    })    
            },
            /*** 
            * Función que se dispara cuando se da clic en Desactivar tipo de cliente
            */
            handleActivate (index, row) {
                var vm = this;
                swal({
                    title: '¿Estás seguro?',
                    text: 'Si aceptas, activarás la parametrización seleccionada',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Si, activar',
                    cancelButtonText: 'No, cancelar',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    buttonsStyling: false
                }).then(() => {
                    var vm = this;
                    var formInput = {};
                    var formMessage = ""; 
                    vm.isSending = true;
                    // Asignar los valores from y to de la fila al modelo
                    vm.model.id = row.id
                    vm.model.from = row.from;
                    vm.model.to = row.to;
                    vm.model.active = true;

                    // Inicializar los valores de client types en el modelo
                    vm.clientTypes_array.forEach(type => {
                        // Asumimos que el objeto `row` tiene las claves correspondientes a los tipos de cliente
                        // Por ejemplo: row.ELITE, row.ELITE_PLUS, etc.
                        vm.model[type.name] = row.data[type.name] !== undefined ? row.data[type.name] : null;
                    });
                    var new_id = vm.idDecode(vm.model.id);
                    let { id, ...modelWithoutId } = vm.model;
                    formInput = {
                        id: new_id,
                        data: JSON.stringify(modelWithoutId)
                    };
                    
                    // Iniciamos el envío de la mutación
                    this.$apollo.mutate({
                        mutation: CREATE_AMOUNT_TERMS_FA,
                        variables : {
                            input : formInput
                        }
                    }).then((data) => {
                        if (data.data.amountTermsFa.errors.length == 0) {
                            let indexToDelete = vm.tableData.findIndex((tableRow) => tableRow.id === row.id)
                            if (indexToDelete >= 0) {
                                vm.tableData.splice(indexToDelete, 1)
                            }
                            vm.pushAmountData(data.data.amountTermsFa.amountTermsFA);
                            vm.isSending = false;
                            swal({
                            title: '¡Desactivada!',
                            text: 'La parametrización ha sido activada',
                            type: 'success',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            buttonsStyling: false
                            }).then(() => {
                                vm.reloadData();
                            },function (dismiss){
                                vm.reloadData();
                            });
                        }
                        else {
                            vm.isSending = false;
                            vm.showNotificationError(data.data.amountTermsFa.errors[0].messages[0]);
                        }
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.onError('Ha ocurrido un error, inténtalo de nuevo');
                    });
                    
                }, function (dismiss) {
                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                    swal({
                        title: 'Cancelado',
                        text: 'La parametrización no ha sido activada',
                        type: 'error',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        buttonsStyling: false
                    })
                    })    
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /***
            * Función para setear en la tabla los datos que llegan desde la Regional
            */
            setClientTypes(clientTypes){
                var vm = this;
                for(let i=0;i<clientTypes.edges.length;i++)
                {
                    vm.pushClientTypesData(clientTypes.edges[i].node);
                }
                vm.orderClientTypesData();  
            },
            /***
            * Función para setear en la tabla los datos que llegan desde la Regional
            */
            setContingentQuotasTdcPyme(contingentQuotasTdcPyme){
                var vm = this;
                for(let i=0;i<contingentQuotasTdcPyme.edges.length;i++)
                {
                    vm.pushData(contingentQuotasTdcPyme.edges[i].node);
                }
            },
            /***
            * Función para setear en la tabla los datos que llegan desde la Regional
            */
            setAmountTermsWc(amountTermsFa){
                var vm = this;
                for(let i=0;i<amountTermsFa.edges.length;i++)
                {
                    vm.pushAmountData(amountTermsFa.edges[i].node);
                }
            },
            /*** 
            * Función que valida si se está enviando o cargando datos
            */
            handleLoading(){
            if(isLoading == true || isSending == true){
                return true
            }
            else{
                return false
            }
            },
            /*** 
            * Función que se dispara cuando se da clic en Agregar tipo de cuota contingente
            */
            handleAdd (){
                var vm = this;
                vm.clientTypes_array.forEach(type => {
                    // Añade el nombre como clave en el model, con valor inicial null
                    vm.$set(vm.model, type.name, null);
                });
                let promise = new Promise(function(resolve, reject) {
                    vm.resetForm();
                    vm.formName = 'Agregar monto y plazo';
                    vm.setVisibleForm(true,false,false)//Asignamos las variables de visualización del formulario
                    vm.errors.clear();//Borramos las validaciones en los campos.
                    resolve();
                }).then(function(resolve){
                    vm.focusFirstField();
                });
                
            },
            /*** 
            * Función que se dispara cuando se da clic en Editar tipo de cuota contingente
            */
            handleEdit (index, row) {
                var vm = this;
                vm.rowEdit = row;
                let promise = new Promise(function(resolve, reject) {
                    vm.formName = 'Editar monto y plazo';
                     // Asignar los valores from y to de la fila al modelo
                    vm.model.id = row.id
                    vm.model.from = row.from;
                    vm.model.to = row.to;

                    // Inicializar los valores de client types en el modelo
                    vm.clientTypes_array.forEach(type => {
                        // Asumimos que el objeto `row` tiene las claves correspondientes a los tipos de cliente
                        // Por ejemplo: row.ELITE, row.ELITE_PLUS, etc.
                        vm.model[type.name] = row.data[type.name] !== undefined ? row.data[type.name] : null;
                    });
                    vm.setVisibleForm(false,true,false)//Asignamos las variables de visualización del formulario
                    vm.errors.clear();//Borramos las validaciones en los campos.
                    resolve();
                }).then(function(resolve){
                    vm.focusFirstField();
                });
            },
            /*** 
            * Función que se dispara cuando se da clic en Editar monto y plazo
            */
            handleShow (index, row) {
                var vm = this;
                vm.rowShow = row;
                let promise = new Promise(function(resolve, reject) {
                    vm.formName = 'Ver monto y plazo';
                     // Asignar los valores from y to de la fila al modelo
                    vm.model.id = row.id
                    vm.model.from = row.from;
                    vm.model.to = row.to;

                    // Inicializar los valores de client types en el modelo
                    vm.clientTypes_array.forEach(type => {
                        // Asumimos que el objeto `row` tiene las claves correspondientes a los tipos de cliente
                        // Por ejemplo: row.ELITE, row.ELITE_PLUS, etc.
                        vm.model[type.name] = row.data[type.name] !== undefined ? row.data[type.name] : null;
                    });
                    vm.setVisibleForm(false,false,true)//Asignamos las variables de visualización del formulario
                    vm.errors.clear();//Borramos las validaciones en los campos.
                    resolve();
                }).then(function(resolve){
                    vm.focusFirstField();
                });
            },
            /**
            * Función que pone el foco en el campo de code
            */
            focusFirstField(){
                var vm = this;
                if(vm.addAmountTermsFA)
                {
                    this.$refs.from.$el.children[0].focus();//Asignamos focus en el campo
                }
                else if(vm.editAmountTermsFA)
                {
                    this.$refs.from.$el.children[0].focus();//Asignamos focus en el campo
                }
            },
            /**
            * Función para asignar el true o false a las opciones de agregar y editar tipos de cuota contingente
            */
            setVisibleForm(add,edit,show)
            {
                this.addAmountTermsFA = add;
                this.editAmountTermsFA = edit;
                this.showAmountTermsFA = show;
            },
            /*** 
            * Función que resetea el formulario
            */
            resetForm(){
                this.model.id = '';
                this.model.from = '';
                this.model.to = '';
                
            },
            /*** 
            * Función que cancela la creación/edición de tipo de cuota contingente y resetea los campos
            */
            cancelForm(){
                this.resetForm();
                this.addAmountTermsFA = false;
                this.editAmountTermsFA = false;
                this.showAmountTermsFA = false;
                this.errors.clear();
                window.scrollTo(0,0);
                // this.$router.go();
            },
            /*** 
            * Función que permite visualizar los errores en cada campo del input
            */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /*** 
            * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro exitoso
            */
            onSuccess(message){
                swal({
                    title: `¡Correcto!`,
                    text: message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    type: 'success'
                });
            },
            /*** 
            * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro erróneo
            */
            onError(message){
                swal({
                    title: `¡Alerta!`,
                    text: message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-danger btn-fill',
                    type: 'error'
                });
            },
            /*** 
            * Función que oculta el formulario de creación/edición una vez realizado un envío de datos al servidor
            */
            reloadData(){
                var vm = this;
                vm.resetForm();
                vm.setVisibleForm(false,false,false)//Asignamos las variables de visualización del formulario 
            },
            /***
            * Función para agregar un objeto al arreglo de datos
            */
            pushData(node){
                var vm = this;
                vm.tableData.push({
                    id: node.id,
                    code: node.data.code,
                    name: node.data.name,
                    balance: node.data.balance,
                    quota: node.data.quota
                });
            },
            /***
            * Función para agregar un objeto al arreglo de datos
            */
            pushAmountData(node){
                var vm = this;
                vm.tableData.push({
                    id: node.id,
                    from: node.data.from,
                    to: node.data.to,
                    data: node.data,
                    active: node.data.active
                });
            // Ordenar tableData por from de menor a mayor
            vm.tableData.sort((a, b) => a.from - b.from);
            },
            /***
            * Función para agregar un objeto al arreglo de datos
            */
            pushClientTypesData(node){
                var vm = this;
                vm.clientTypes_array.push({
                    id: node.id,
                    code: node.code,
                    name: node.name,
                    isActive: node.isActive,
                });
            },
            /***
            * Función para ordenar el arreglo de datos
            */
            orderData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.tableData, o => o.name);
                vm.tableData = myOrderedArray;
            },
            /***
            * Función para ordenar el arreglo de datos
            */
            orderClientTypesData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.clientTypes_array, o => o.name);
                vm.clientTypes_array = myOrderedArray;
            },
            /***
            * Función para decodificar el ID en base 64
            */
            idDecode(id){
                let id_decoded = atob(id);
                return id_decoded.split(":")[1];
            },
            /***
            * Función para mostrar un mensaje de error
            */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /***
            * Función para validar el formulario de edición y creación que se envía
            */
            validate () {
                this.$validator.validateAll().then(isValid => {
                if(isValid){
                    // this.$emit('on-submit', this.registerForm, isValid)
                    var vm = this;
                    var formInput = {};
                    var formMessage = ""; 
                    vm.isSending = true;
                    // Parsear "from" y "to" a números
                    let fromValue = Number(vm.model.from);
                    let toValue = Number(vm.model.to);

                    // Verificar que el "from" sea menor que el "to"
                    if (isNaN(fromValue) || isNaN(toValue)) {
                        vm.onError('Los valores de "Desde" y "Hasta" deben ser números válidos.');
                        vm.isSending = false;
                        return;
                    }
                    if (fromValue >= toValue) {
                        vm.onError('El valor de "Desde" debe ser menor que "Hasta".');
                        vm.isSending = false;
                        return;
                    }
                    if(vm.addAmountTermsFA && !vm.editAmountTermsFA)
                    {
                        let { id, ...modelWithoutId } = vm.model;
                        formInput = {
                            data: JSON.stringify(modelWithoutId)
                        };
                        formMessage = "Monto y plazo registrado con éxito";
                    }
                    else if(!vm.addAmountTermsFA && vm.editAmountTermsFA)
                    {
                        var new_id = vm.idDecode(vm.model.id);
                        let { id, ...modelWithoutId } = vm.model;
                        formInput = {
                            id: new_id,
                            data: JSON.stringify(modelWithoutId)
                        };
                        formMessage = "Monto y plazo editado con éxito";
                    }
                    // Iniciamos el envío de la mutación
                    this.$apollo.mutate({
                        mutation: CREATE_AMOUNT_TERMS_FA,
                        variables : {
                            input : formInput
                        }
                    }).then((data) => {
                        if (data.data.amountTermsFa.errors.length == 0) {
                            if(!vm.addAmountTermsFA && vm.editAmountTermsFA)
                            {
                                let indexToDelete = vm.tableData.findIndex((tableRow) => tableRow.id === vm.rowEdit.id)
                                if (indexToDelete >= 0) {
                                    vm.tableData.splice(indexToDelete, 1)
                                }
                            }
                            vm.pushAmountData(data.data.amountTermsFa.amountTermsFA);
                            vm.isSending = false;
                            vm.onSuccess(formMessage);
                            vm.reloadData();
                        }
                        else {
                            vm.isSending = false;
                            vm.showNotificationError(data.data.amountTermsFa.errors[0].messages[0]);
                        }
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.onError('Ha ocurrido un error, inténtalo de nuevo');
                    });
                }
                })
        }
        },
        mounted() {
            // this.test();
            // alert(this.$window.csrf_token);
        }
    }
    </script>
    <style lang="scss">
    .el-table .td-actions{
    button.btn {
        margin-right: 5px;
    }
    }
    // Función para centrar la imagen del Empty State
    .no_data_center {
        display: block;
        margin-left: auto;
        margin-right: auto;
        max-width: 500px;
    }
    // Estilos para poder centrar el título de la Regional
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
</style>
